import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  faTasks,
  faUser,
  faMoneyCheckAlt,
  faChartLine,
  faClipboardCheck,
  faUserCheck,
  faFileCheck,
  faFileUpload,
} from '@fortawesome/pro-light-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss'],
})
export class RoadmapComponent implements OnInit {
  @Input() step: string;
  // @Input() stepInt: string;
  public stepInt: number;
  public faTasks = faTasks;
  public faChartLine = faChartLine;
  public faUser = faUser;
  public faMoneyCheckAlt = faMoneyCheckAlt;
  public faClipboardCheck = faClipboardCheck;
  public faUserCheck = faUserCheck;
  public faFileUpload = faFileUpload;
  public faFileCheck = faFileCheck;
  public updateData: boolean = false;

  //Esta estructura se hace para facilitar la creaccion de los step en la vista
  //Se añade un setpid para que los pasos float (ej:4.1) puedan verse bien en la vista
  public steps = [];

  constructor(
    private translate: TranslateService,
    private router: Router,
    private commonService: CommonService,
    @Inject(DOCUMENT) private document: any
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.stepInt = this.saveStep(this.step);
      this.loadTexts();
      this.receiveData();
    });
  }

  private saveStep<int>(step) {
    switch (step) {
      case '4.v':
        this.updateData = true;
        return 6;
      case '4.e':
        this.updateData = true;
        return 7;
      default:
        return parseInt(step);
    }
  }

  loadTexts() {
    let text01 = '';
    let text02 = '';
    let text03 = '';
    let text04 = '';
    let text05 = '';
    let text06 = '';
    let text07 = '';
    let text08 = '';
    let text09 = '';
    let text10 = '';
    let text11 = '';
    this.translate.get('k002660').subscribe((text) => {
      text01 = text; //token: Test de riesgo
    });
    this.translate.get('k002661').subscribe((text) => {
      text02 = text;
      //Token: Este cuestionario nos permite determinar el perfil más adecuado para tu inversion
    });
    this.translate.get('k002662').subscribe((text) => {
      text03 = text;
      //Token: Tu aportación inicial
    });
    this.translate.get('k002663').subscribe((text) => {
      text04 = text;
      //Token: Elige la cartera más adecuada a tu perfil y la contribución inicial
    });
    this.translate.get('k002664').subscribe((text) => {
      text05 = text;
      //Token: Tus datos
    });
    this.translate.get('k002665').subscribe((text) => {
      text06 = text;
      //Token: Son los datos necesarios que nos permite conocerle y verificar tu identidad
    });
    this.translate.get('k002666').subscribe((text) => {
      text07 = text;
      //Token: Validación de tus datos
    });
    this.translate.get('k002667').subscribe((text) => {
      text08 = text;
      //Token: Tus datos deben ser validados por nuestro equipo administrativo y comprobar que todo es correcto'
    });
    this.translate.get('k003069').subscribe((text) => {
      text09 = text;
      //Token: Documento no aceptado
    });
    this.translate.get('k003070').subscribe((text) => {
      text10 = text;
      //Token: Debes subir nuevamente la documentación solicitada
    });
    this.translate.get('k003071').subscribe((text) => {
      text11 = text;
      //Token: Cuenta confirmada
    });
    this.translate.get('k003072').subscribe((text) => {
      this.steps = [
        {
          step: 2,
          stepid: 2,
          icon: faTasks,
          title: text01, //token: Test de riesgo
          description: text02,
          //Token: Este cuestionario nos permite determinar el perfil más adecuado para tu inversion
        },
        {
          step: 3,
          stepid: 3,
          icon: faChartLine,
          title: text03, //Token: Tu aportación inicial
          description: text04, //Token: Elige la cartera más adecuada a tu perfil y la contribución inicial
        },
        {
          step: 4,
          stepid: 4,
          icon: faUser,
          title: text05, //Token: Tus datos
          description: text06,
          //Token: Son los datos necesarios que nos permite conocerle y verificar tu identidad
        },
        {
          step: 5,
          stepid: 5,
          icon: faUserCheck,
          title: text07, //Token: Validación de tus datos
          description: text08,
          //Token: Tus datos deben ser validados por nuestro equipo administrativo y comprobar que todo es correcto'
        },
        {
          step: 6,
          stepid: 6,
          icon: faFileUpload,
          title: text09, //Token: Documento no aceptado
          description: text10,
          //Token: Debes subir nuevamente la documentación solicitada
        },
        {
          step: 7,
          stepid: 7,
          icon: faFileCheck,
          title: text11, //Token: Cuenta confirmada
          description: text, //Token 'Toda la información y documentación ha sido validada satisfactoriamente',
        },
      ];
    });
  }

  private receiveData() {
    // let stepText: string = '';
    // switch (this.stepInt) {
    //   case 2:
    //   case 3:
    //     stepText = 'k000487';
    //     break;
    //   case 4:
    //   case 5:
    //     stepText = 'k002503';
    //     break;
    //   default:
    //     break;
    // }
    // if (stepText != '') {
    //   this.translate
    //     .get(stepText)
    //     .subscribe((text) =>
    //       this.commonService.setTitle(
    //         this.step + '/5 ' + text + ' | ' + AppConfig.settings.tabTitle
    //       )
    //     );
    // } else {
    //   this.commonService.setTitle(
    //     this.step + '/5 | ' + AppConfig.settings.tabTitle
    //   );
    // }
    this.translate.get('k002901').subscribe((text) => {
      // Token: Continuemos
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });
  }

  public redirect(event) {
    //El paso 2 (test) nunca llega aqui porque se reidrecciona directamente
    switch (this.step) {
      case '2':
        this.router.navigate(['/questionnaire']);
        break;
      case '3': //ModelPortfolioThemes
        this.router.navigate(['/modelportfoliothemes']);
        break;
      case '4': //datos completos
      case '4.1':
        this.router.navigate(['/completedata']);
        break;
      case '4.2': //datos completos employment
        this.router.navigate(['/completedata/employment']);
        break;
      case '4.3': //datos completos declarations
        this.router.navigate(['/completedata/declarations']);
        break;
      case '4.4': //datos completos tax
        this.router.navigate(['/completedata/tax']);
        break;
      case '4.5': //datos completos documentacion
        this.router.navigate(['/completedata/documentation']);
        break;
      case '4.6': //datos completos confirma tu primera contribucion
        this.router.navigate(['/completedata/firstcontribution']);
        break;
      case '4.7': //datos completos Confirma todos tus datos
        this.router.navigate(['/completedata/confirmall']);
        break;
      case '4.8': //datos completos firstContribution
        this.router.navigate(['/completedata/agreements']);
        break;
      case '5': //valida tus datos
        this.router.navigate(['/completedata']);
        break;
      case '4.v': //corregir Documentacion
        this.router.navigate(['/completedata/editdocumentation']);
        break;
      default:
        break;
    }
  }
}
